import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux'

import '../styles/header.scss';
import { MdKeyboardArrowDown } from "react-icons/md";
import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuGroup,
	Text,
	Box,
	Flex,
	Divider,
	useMediaQuery,
	Avatar
} from "@chakra-ui/react";
import NavigationMenuHeader from './NavigationMenuHeader';
import HeaderLogo from './HeaderLogo';
import { getUserAccountType } from '../../../../profile/helpers/user-helper';
import config from '../../../../../config/app-config';
import UserNotificationsModule from './UserNotificationsModule';
import { signOut } from '../../../../auth/actions/auth-actions';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { getUserProfile } from '../../../../profile/actions/users-profile-actions';
import { displayEmoji } from '../../../../digital-sales-room/helpers/dsr-helpers';


function DefaultHeader({
	className,
	history,
	newUserTourIsActive,
	// Action
	signOut,
	getUserProfile,
	// Redux
	userAccountProfile,
	userProfilePicture
}) {
	let pathname = history ? history.location.pathname : '';

	const [displayedName, setDisplayedName] = useState('')
	const [allowAdminPages, setAllowAdminPages] = useState(false)
	const [showHowToGuide, setShowHowToGuide] = useState(false)
	const [showHeaderOptions, setShowHeaderOptions] = useState(true)

	const [isLargerThan1000] = useMediaQuery('(min-width: 1000px)')
	const [noHeader, setNoHeader] = useState("")

	useEffect(() => {
		if (userAccountProfile) {
			const { firstName, lastName } = userAccountProfile || {}

			const lastNameInitial = lastName ? lastName.charAt(0).toUpperCase() + '.' : ""
			const userNameDisplay = firstName ? (firstName + " " + lastNameInitial).trim() : "Manage"

			userNameDisplay && setDisplayedName(userNameDisplay)

		} else {
			getUserProfile({
				getUserInfo: true,
				getUserMetaData: true
			})
		}
	}, [userAccountProfile])

	useEffect(() => {
		const userType = getUserAccountType();

		switch (userType) {
			case ("super-app-admin"): {
				setAllowAdminPages(true)
				setShowHowToGuide(true)
				break;
			}
			case ("active-sub-org-user"):
			case ("no-sub-genesis-org-admin"): {
				setShowHowToGuide(true)
				break;
			}
			default: {
				break;
			}
		}
	}, [])

	useEffect(() => {
		if (history.location.pathname) {
			if (history.location.pathname.startsWith("/edit") || history.location.pathname.startsWith("/notifications")) {
				setShowHeaderOptions(false)
			}
		}
	}, [history.location.pathname])

	const openHowToGuide = () => {
		const { displayUrl } = config;
		window.open(`${displayUrl}/pdsr/launchdeck-how-to-guide`)
	}

	useEffect(() => {
		if (pathname.startsWith('/callback')) {
			setNoHeader(true)
		}
	}, [])

	function renderNavigationMenu() {

		switch (pathname) {
			//"No distraction" pages
			case ('/welcome'):
			case ('/setup-profile'):
			case ('/organization/choose-plan'): {
				return null
			}
			case ('/received-rooms'): {
				return <NavigationMenuHeader isMobileView={!isLargerThan1000} isGuestMode={true} />
			}
			default:
				return <NavigationMenuHeader isMobileView={!isLargerThan1000} />
		}
	}

	function renderAdminDropdown() {
		const handleLogOut = () => {
			window.location.hash = 'logout';
			signOut()
		}

		const renderDropdownButtonUi = () => {
			return (
				<Box data-driver="step-2">
					<Flex justify='space-apart' alignItems='center'>
						{displayedName && <Text mr='0.3em' fontSize='0.875em' width='max-content'>{displayedName} </Text>}
						<Box as={MdKeyboardArrowDown} fontSize='1em' color="brand.500" />
					</Flex>
				</Box>
			)
		}

		switch (pathname) {
			//"No distraction" pages
			case ('/welcome'):
			case ('/setup-profile'):
			case ('/organization/choose-plan'): {
				return null
			}
			default: {
				// pathname
				const isGuestMode = pathname === '/received-rooms'
				const switchCopy = isGuestMode ? 'Manage Rooms' : 'View joined Rooms';
				const linkPath = isGuestMode ? '/home' : '/received-rooms';

				return (
					<Flex
						w='16em'
						mr='2em'
						gap='0.5em'
						alignItems='center'
						justify='space-between'
					>
						<NavLink to={linkPath}>
							<Box
								mr='0.75em'
								fontSize='0.8em'
								p='0.4em 1em'
								rounded='2em'
								fontWeight='600'
								color='gray.500'
								whiteSpace="nowrap"
								sx={{
									_hover: {
										bg: isGuestMode ? 'brand.50' : 'gray.100'
									},
								}}
							>
								{switchCopy}</Box>
						</NavLink>

						<Flex gap='1em' align='center'>
							{!!showHeaderOptions && !newUserTourIsActive &&
								<Flex position='relative'>
									<UserNotificationsModule />
								</Flex>
							}

							{newUserTourIsActive ? renderDropdownButtonUi()
								:
								<Menu ml='2em' placement="bottom-end">
									<MenuButton color='gray.600' isDisabled={true}>
										<Flex align='flex-end'>
											<Avatar h='3em' w='3em' name={displayedName} bg='gray.100' color='gray.700' src={userProfilePicture} />
											<Box as={MdKeyboardArrowDown} fontSize='1.2em' color="brand.500" />
										</Flex>
									</MenuButton>
									<MenuList minW='8em' px='0.5em'>
									
							
												{displayedName && 
															<Flex w='100%' fontSize='0.875em' justify='flex-start' align='flex-start' gap='0.5em' p='0.5em'>
																		
											<Text  fontWeight='600' color='brandDark.500' width='max-content'>{displayedName} </Text>
											<Box>{displayEmoji('wave')}</Box>
															</Flex>
												}
						
										<Divider mb='0.5em' />
										<MenuGroup title='Profile' ml='0.5em' mr='4em' color='brand.500' fontSize='0.75em' letterSpacing='1px' >
											<MenuItem color='gray.700' py='0.2em' onClick={() => history.push('/profile')}>
												<Text className="header__profile-info-type">
													My Account
												</Text>
											</MenuItem>

											<MenuItem py='0.2em' onClick={() => history.push('/support')} >
												<Text className="header__profile-info-type">
													Support
												</Text>
											</MenuItem>
										</MenuGroup>

										{!!allowAdminPages &&
											<MenuGroup title='Super App Admin'mt='2em' ml='0.5em' mr='4em' color='brand.500' fontSize='0.75em' letterSpacing='1px' >
												<MenuItem py='0.2em' onClick={() => history.push('/saa/manage')} >
													<Text className="header__profile-info-type">
														User & Org Setup
													</Text>
												</MenuItem>
											</MenuGroup>
										}



										<Divider mt='2em' mb='0.5em' />

										<MenuGroup ml='0.5em' mr='4em' >
											{!!showHowToGuide &&
												<MenuItem py='0.2em' onClick={() => openHowToGuide()} >
													<Text className="header__profile-info-type">
														Launchdeck's How-To Guide
													</Text>
												</MenuItem>
											}
											<MenuItem onClick={handleLogOut} >
												<Box verticalAlign='center' className="header__profile-info-type">
													Log out
												</Box>
											</MenuItem>

										</MenuGroup>
									</MenuList>
								</Menu>
							}
						</Flex>
					</Flex>
				)
			}

		}
	}

	if (noHeader) {
		return (
			<nav className={`${className} header header--default`}>
				<Flex w='100%' justify='center'>
					<Flex className='dsr-header-item-container'>
						<Box className="header__container">
							<HeaderLogo />
						</Box>
					</Flex>
				</Flex>
			</nav>
		)
	} else {
		return (
			<nav className={`${className} header header--default`}>
				<Flex w='100%' justify='center'>
					<Flex className='dsr-header-item-container'>
						<Box flex='1' className="header__container">
							<HeaderLogo />
						</Box>

						<Box flex='auto' className="header__nav-bar-container header__title">
							{renderNavigationMenu()}
						</Box>

						<Box flex='1'>
							{renderAdminDropdown()}
						</Box>
					</Flex>
				</Flex>
			</nav>
		);
	}
}

function mapStateToProps(state) {
	return {
		userAccountProfile: state.userProfile.accountUserProfile,
		userProfilePicture: state.thisUserProfilePicture.result,
	};
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			signOut,
			getUserProfile
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DefaultHeader));